import React, { memo } from 'react'

import { Icon, CubeOutline } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import UploadThreeDModelButton from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/UploadThreeDModelButton'

function ViewerHeader() {
  const t = useTranslation()

  return (
    <div className="header__viewer">
      <div className="header__title-wrapper">
        <Icon svgComponent={CubeOutline} color="dark" size={iconSizeMedium} notSpaced />
        <span className="header__title">{t('header.viewer')}</span>
      </div>
      <UploadThreeDModelButton withLabel />
    </div>
  )
}

export default memo(ViewerHeader)
